module.exports = __webpack_public_path__ + "media/images/profile/fallback-header-d85cd3539f95caf720e3f4111a1fcc14.jpg";